
import {  MenuProps, Menu } from '@mui/material'
import React from 'react'

export type WcMenuProps = MenuProps

export const WcMenu = ({children,...props}: WcMenuProps) => (
    <Menu {...props}>
      {children}
    </Menu>
  )